import React from "react";
import { RateShopStyledTableCell } from ".";

export const RateShopTableRows = ({ item, index, columns, }) => {
  return columns.map((column) => (
    <RateShopStyledTableCell
      key={`${column?.id}-tableCell`}
      style={{ ...(column?.style || {}), height: "auto !important" }}
    >
      {column?.renderValue(item, index)}
    </RateShopStyledTableCell>
  ));
};
